import React from 'react'
import ClaimCustomizeIframe from "./ClaimCustomizeIframe";

class SubmitClaimFailed extends React.Component{
  constructor() {
    super()

    this.state = {
      debuggerMode: false
    }
  }

  buildJSON(payload) {
    if (JSON.stringify(payload) === JSON.stringify({})) {
      return null
    } else {
      return JSON.stringify(payload, undefined, 2)
    }
  }

  renderDebuggerMode() {
    return (
      <div>
        <div className='payload-response'>
          <div className='response-title'>
            Request
          </div>
          <pre className='response-detail'>
            { this.buildJSON(this.props.request) }
          </pre>
        </div>
        <div className='payload-response'>
          <div className='response-title'>
            Response
          </div>
          <pre className='response-detail'>
            { this.buildJSON(this.props.response) }
          </pre>
        </div>
      </div>
    )
  }

  renderClaimFailedBody() {
    const { customizable_screen_content, request_recipient, leave_scenario } = this.props
    const { claim_failed } = customizable_screen_content

    if (claim_failed) {
      return <ClaimCustomizeIframe content={claim_failed} />
    }

    const faCheckDivStyle = {
      height: 84,
      minWidth: 96,
      display: 'flex',
      justifyContent: 'center',
      border: '10px solid #8BC758',
      alignItems: 'center',
      borderRadius: 10
    }
    const faCheckStyle = {
      fontSize: 48,
      color: '#8BC758'
    }
    return (
      <div className='claim-requested-body'>
        <div className='claim-requested-leave'>
          <div style= { faCheckDivStyle }>
            <i className='fa fa-arrow-up' style={ faCheckStyle }></i>
          </div>
          <div className='submit-claim-circle-check'>
            We have submitted your
            Leave of Absence Request
            for your {leave_scenario} to {request_recipient}.
          </div>
        </div>
        <div className='claim-happens-text'>
          <strong> What happens now? </strong><br/>
          There may have been an issue filing your claim with {request_recipient}.
          Pleave contact LeaveLogic support through in-App chat
          at the bottom right of your screen.
        </div>
      </div>
    )
  }

  renderNormalMode() {
    return (
      <div className="submit-claim-div col-lg-10">
        <div className='submit-claim-success-text'>
          There may have been an issue processing your claim.
        </div>
        { this.renderClaimFailedBody()}

        <div className='back-to-claim-btn col-md-8 col-md-offset-4'>
          { this.props.redirectButton() }
        </div>
      </div>
    )
  }

  renderDebuggerModeSwitch() {
    let switchText = 'Switch to Debugger Mode'
    if (this.state.debuggerMode) {
      switchText = 'Switch to Normal Mode'
    }
    return this.props.is_admin ? (
      <span
        className='submit-view-switch'
        onClick={(e) => this.setState({debuggerMode: !this.state.debuggerMode})}
      >
        { switchText }
      </span>
    ) : null
  }

  renderSection() {
    if (this.state.debuggerMode) {
      return this.renderDebuggerMode()
    } else {
      return this.renderNormalMode()
    }
  }

  render () {
    return (
      <div className='claim-container'>
        <div className='submit-view-buttons'>
          <a
            className='submit-view-switch'
            href={`/claims/${this.props.id}/edit`}
          >
            Edit
          </a>
          { this.renderDebuggerModeSwitch() }
        </div>
        { this.renderSection() }
      </div>
    )
  }
}

export default SubmitClaimFailed;